/* ===========================================================================
   Forever Liss — LP da loja internacional oficial dentro da MKPBR
   Criada em 19/09/2026 no molde da Popozuda: ficha do produto, carrinho
   proprio, busca local, seletores e faixa de mercado — mais o que a home
   oficial da marca tem: carrossel do banner com setas e bolinhas, os cartoes
   "Do que seu cabelo sente falta?", as vitrines em carrossel (Ofertas,
   Lancamentos, Mais vendidos, Kits) e a vitrine completa por LINHA.

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #fl-cfg.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var REDUZ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[forever-liss] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('fl-cfg', {});
  var RAW = readJSON('fl-data', []);
  var ISO = CFG.iso || D.documentElement.lang || 'en';
  var PACK = readJSON('fl-i18n', {});
  function t(k) { return PACK[k] || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtNum(n) {
    try { return new Intl.NumberFormat(ISO + '-u-nu-latn').format(n); } catch (e) { return String(n); }
  }

  /* O Liquid devolve numero como texto em varios campos (a nota chega como
     "4.9"). Converte UMA vez, logo depois de ler o JSON. */
  function normVar(v) {
    v.pr = Number(v.pr) || 0;
    v.prf = String(v.prf == null ? '' : v.prf);
    v.cmpf = v.cmpf ? String(v.cmpf) : null;
    v.av = v.av === true || v.av === 'true';
    v.t = String(v.t == null ? '' : v.t);
    return v;
  }
  function tagSet(p) { return p.tags.map(function (x) { return String(x).toLowerCase(); }); }
  function ehKit(p) {
    var h = String(p.h).toLowerCase();
    return tagSet(p).indexOf('hair gift set') > -1 || /-kit$|-kit-|-set$|-set-/.test(h);
  }
  function prepara(lista) {
    return (lista || []).filter(function (p) { return p && p.h && p.v && p.v.length; }).map(function (p) {
      p.v = p.v.map(normVar);
      p.img = Array.isArray(p.img) ? p.img.filter(function (i) { return i && i.s; }) : [];
      p.tags = Array.isArray(p.tags) ? p.tags : [];
      p.rr = p.rr == null ? null : parseFloat(p.rr);
      if (!isFinite(p.rr)) p.rr = null;
      p.rc = Math.round(parseFloat(p.rc) || 0);
      p.c = String(p.c || '');
      p.av = p.v.some(function (v) { return v.av; });
      var disp = p.v.filter(function (v) { return v.av; });
      var base = (disp.length ? disp : p.v).slice().sort(function (a, b) { return a.pr - b.pr; });
      p.min = base[0];
      /* "a partir de" so quando os precos REALMENTE diferem */
      p.faixa = p.v.length > 1 && p.v.some(function (v) { return v.pr !== p.v[0].pr; });
      p.multi = p.v.length > 1;
      p.isKit = ehKit(p);
      p.isNew = !!(CFG.newSince && p.c && p.c >= String(CFG.newSince));
      p.need = (CFG.need && CFG.need[p.h]) || '';
      return p;
    });
  }
  var PRODUCTS = prepara(RAW);
  function porHandle(h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  }

  /* ---------- dinheiro ---------------------------------------------------
     Cards e ficha usam v.prf, que o Liquid ja formatou. No carrinho, o
     #fl-cfg traz 12345,67 formatado pela loja: daqui sai o simbolo, a posicao
     e os separadores — o carrinho fica igual aos cards. */
  var CURRENCY = CFG.cur || 'USD';
  var MF = (function (tpl) {
    var m = /\d[\d.,'\s  ]*\d/.exec(String(tpl || ''));
    if (!m) return null;
    var num = m[0], dec = /([.,])\d{2}$/.exec(num), mil = /^12(\D+)34/.exec(num);
    return { pre: tpl.slice(0, m.index), pos: tpl.slice(m.index + num.length), dec: dec ? dec[1] : '', sep: mil ? mil[1] : '' };
  })(CFG.mfmt);
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    if (MF && CURRENCY === CFG.cur) {
      var casas = MF.dec ? 2 : 0, fix = n.toFixed(casas).split('.');
      var inteiro = fix[0].replace(/\B(?=(\d{3})+(?!\d))/g, MF.sep);
      return MF.pre + inteiro + (casas ? MF.dec + fix[1] : '') + MF.pos;
    }
    try { return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n); }
    catch (e) { return CURRENCY + ' ' + n.toFixed(2); }
  }
  function parseMoney(s) {
    var n = String(s == null ? '' : s).replace(/[^\d.,]/g, '');
    if (!n) return NaN;
    var dec = /[.,](\d{1,2})$/.exec(n);
    if (dec) return parseFloat(n.slice(0, n.length - dec[0].length).replace(/[.,]/g, '') + '.' + dec[1]);
    return parseFloat(n.replace(/[.,]/g, ''));
  }

  /* ---------- nome curto ---------------------------------------------------
     O titulo da MKPBR e longo (tamanho, beneficios, "Forever Liss" na frente).
     No CARD vai o nome ate o primeiro separador, sem a marca na frente (a LP
     inteira ja e da marca); a ficha e o aria-label levam o titulo completo. */
  function curto(p) {
    var s = String(p.t || '');
    var m = s.split(/\s[–—-]\s|\s\|\s|:\s|：|\s\(|（|、|،\s/)[0];
    if (!m || m.length < 8) m = s;
    m = m.replace(/^\s*Forever\s+Liss\s+/i, '').replace(/\s+(by|de|di|par|von|door|por)\s+Forever\s+Liss\s*$/i, '').trim();
    return m || s;
  }
  function curtoLinha(it) {
    var p = porHandle(it.handle);
    return p ? curto(p) : (it.product_title || it.title);
  }

  /* ---------- imagens com srcset -------------------------------------------- */
  function imgW(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(src) { return [300, 450, 600].map(function (w) { return imgW(src, w) + ' ' + w + 'w'; }).join(', '); }

  /* ---------- selo da Entrega Garantida --------------------------------------
     Abaixo de ~20px a arte oficial (que tem texto) vira borrao: no micro-selo
     do card entra o escudo em SVG. */
  var ESCUDO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SELO = CFG.seloUrl ? '<img class="fl-selo-img" src="' + esc(CFG.seloUrl) + '" alt="" width="120" height="126" loading="lazy">' : ESCUDO;
  /* sacola do botao COMPRAR do card oficial */
  var SACOLA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5.5 8.5h13l-.9 11.4a1.4 1.4 0 0 1-1.4 1.3H7.8a1.4 1.4 0 0 1-1.4-1.3L5.5 8.5Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 10.5V7a3 3 0 0 1 6 0v3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  /* ---------- cards ---------------------------------------------------------- */
  function desconto(v) {
    if (!v || !v.cmpf) return null;
    var de = parseMoney(v.cmpf), por = parseMoney(v.prf);
    if (!isFinite(de) || !isFinite(por) || de <= por) return null;
    return { pct: Math.round((1 - por / de) * 100) };
  }
  /* preco "de" so aparece com desconto de verdade (>= 5%): no cadastro ha
     variante com preco "de" 1 centavo acima do preco — ruido, nao oferta */
  function riscado(v) { var d = desconto(v); return d && d.pct >= 5 ? v.cmpf : null; }
  function precoHTML(p, v) {
    v = v || p.min;
    var de = riscado(v);
    return (de ? '<s>' + esc(de) + '</s>' : '') +
      '<b>' + (p.faixa && v === p.min ? '<small>' + esc(t('from')) + '</small> ' : '') + esc(v.prf) + '</b>';
  }
  function badgesHTML(p, v) {
    var d = desconto(v || p.min);
    if (!d || d.pct < 5) return '';
    return '<span class="fl-b">' + d.pct + '% ' + esc(t('off')) + '</span>';
  }
  /* Estrelas SO quando o produto tem nota cadastrada (metafield de reviews). Nada de nota inventada. */
  function starsHTML(p) {
    if (!p.rr || !p.rc) return '';
    var cheias = Math.round(p.rr);
    return '<div class="fl-stars" aria-label="' + esc(p.rr.toFixed(1) + ' / 5') + '"><i aria-hidden="true">' +
      '★★★★★'.slice(0, cheias) + '☆☆☆☆☆'.slice(0, 5 - cheias) + '</i>(' + fmtNum(p.rc) + ')</div>';
  }
  function imgHTML(p) {
    var img = p.img[0] || {};
    var d = desconto(p.min);
    /* v2: segunda foto (textura, tamanho, detalhe) so em aparelho com mouse */
    var hv = (CFG.v2 && CFG.v2.hov && CFG.v2.hov[p.h]) ? fotoDe(p, CFG.v2.hov[p.h]) : null;
    return '<div class="fl-card__img">' +
      (img.s ? '<img src="' + esc(imgW(img.s, 450)) + '" srcset="' + esc(srcset(img.s)) + '" sizes="(max-width:767px) 46vw, 300px"' +
        ' alt="' + esc(img.a || p.t) + '" loading="lazy" decoding="async" width="600" height="600">' : '') +
      (hv && hv.s ? '<img class="fl-card__img2" src="' + esc(imgW(hv.s, 450)) + '" alt="" aria-hidden="true" loading="lazy" decoding="async" width="600" height="600">' : '') +
      (!p.av ? '<span class="fl-card__flag">' + esc(t('soldout')) + '</span>' :
        (d && d.pct >= 5 ? '<span class="fl-card__off">' + d.pct + ' % ' + esc(t('off')) + '</span>' :
          (p.isNew ? '<span class="fl-card__off fl-card__off--new">' + esc(t('new_b')) + '</span>' : ''))) +
    '</div>';
  }
  /* O card NAO pode ser um <button> (botao dentro de botao e HTML invalido):
     div com role=button, e o clique no botao de comprar e tratado ANTES. */
  function cardEl(p) {
    var el = D.createElement('div');
    el.className = 'fl-card' + (p.av ? '' : ' fl-card--out');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', p.t);
    el.dataset.flHandle = p.h;
    var rotulo = !p.av ? t('soldout') : (p.multi ? t('pdp_choose_card') : t('add'));
    var attr = p.multi ? ' data-fl-open-handle="' + esc(p.h) + '"' : ' data-fl-add="' + p.min.id + '"';
    el.innerHTML = imgHTML(p) +
      '<div class="fl-card__body">' +
        (p.need && t('cat_' + p.need) ? '<span class="fl-card__need">' + esc(t('cat_' + p.need)) + '</span>' : '') +
        '<h3>' + esc(curto(p)) + '</h3>' +
        (temTamanhos(p) ? '<span class="fl-card__sz">' + esc(t('sz_n').replace('{n}', fmtNum(p.v.length))) + '</span>' : '') +
        starsHTML(p) +
        '<div class="fl-card__price">' + precoHTML(p) + '</div>' +
        /* micro-selo da Entrega Garantida: responde antes do clique */
        '<span class="fl-card__del">' + ESCUDO + esc(t('del_card')) + '</span>' +
        '<button type="button" class="fl-card__add"' + attr + (p.av ? '' : ' disabled') + ' aria-label="' + esc(rotulo + ' — ' + curto(p)) + '"><span>' + esc(rotulo) + '</span>' + SACOLA + '</button>' +
      '</div>';
    return el;
  }
  function pinta(grid, lista) {
    if (!grid) return;
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'false');
    lista.forEach(function (p) { grid.appendChild(cardEl(p)); });
  }
  /* disponivel antes de esgotado; dentro disso, a ordem da lista */
  function dispPrimeiro(lista) {
    return lista.map(function (p, i) { return { p: p, i: i }; })
      .sort(function (a, b) { return (a.p.av === b.p.av) ? a.i - b.i : (a.p.av ? -1 : 1); })
      .map(function (x) { return x.p; });
  }
  function daLista(handles) { return (handles || []).map(porHandle).filter(Boolean); }
  function lista(k) {
    if (k === 'best') return dispPrimeiro(daLista(CFG.best));
    if (k === 'news') return dispPrimeiro(PRODUCTS.filter(function (p) { return p.isNew; }));
    if (k === 'kits') return dispPrimeiro(PRODUCTS.filter(function (p) { return p.isKit; }));
    if (k === 'offers') {
      return PRODUCTS.filter(function (p) { var d = desconto(p.min); return p.av && d && d.pct >= 5; })
        .sort(function (a, b) { return desconto(b.min).pct - desconto(a.min).pct; }).slice(0, 12);
    }
    return [];
  }

  /* ---------- carrossel de cards: scroll NATIVO; setas e bolinhas acompanham ---------- */
  function paginas(track) {
    var card = $('.fl-card', track);
    if (!card) return { n: 1, por: 1, passo: track.clientWidth };
    var passo = card.getBoundingClientRect().width + 16;
    var por = Math.max(1, Math.round(track.clientWidth / passo));
    var total = track.children.length;
    return { n: Math.max(1, Math.ceil(total / por)), por: por, passo: passo };
  }
  function atualizaRail(rail) {
    if (!rail) return;
    var track = $('.fl-rail__track', rail);
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var x = Math.abs(track.scrollLeft); /* em RTL o Chrome devolve scrollLeft negativo */
    var sobra = max > 4;
    var prev = $('[data-fl-rail-prev]', rail), next = $('[data-fl-rail-next]', rail);
    if (prev) { prev.disabled = !sobra || x < 8; prev.hidden = !sobra; }
    if (next) { next.disabled = !sobra || x > max - 8; next.hidden = !sobra; }
    var dots = $('[data-fl-rail-dots]', rail);
    if (dots) {
      var pg = paginas(track);
      if (!sobra || pg.n < 2) { dots.innerHTML = ''; return; }
      if (dots.childElementCount !== pg.n) {
        var h = '';
        for (var i = 0; i < pg.n; i++) h += '<button type="button" data-fl-dot="' + i + '" aria-label="' + esc(t('slide') + ' ' + (i + 1)) + '"></button>';
        dots.innerHTML = h;
      }
      var atual = x > max - 8 ? pg.n - 1 : Math.round(x / (pg.passo * pg.por));
      $$('button', dots).forEach(function (b, i) { if (i === atual) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    }
  }
  function ligaRail(rail) {
    if (!rail) return;
    var track = $('.fl-rail__track', rail);
    if (!track) return;
    if (!rail.dataset.pronto) {
      rail.dataset.pronto = '1';
      track.addEventListener('scroll', function () { atualizaRail(rail); }, { passive: true });
      track.addEventListener('load', function () { atualizaRail(rail); }, true);
      $$('[data-fl-rail-prev],[data-fl-rail-next]', rail).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var dir = b.hasAttribute('data-fl-rail-next') ? 1 : -1;
          if (D.documentElement.dir === 'rtl') dir = -dir;
          var pg = paginas(track);
          track.scrollBy({ left: dir * pg.passo * pg.por, behavior: REDUZ ? 'auto' : 'smooth' });
        });
      });
      var dots = $('[data-fl-rail-dots]', rail);
      if (dots) dots.addEventListener('click', function (e) {
        var b = e.target.closest('[data-fl-dot]');
        if (!b) return;
        e.preventDefault(); e.stopPropagation();
        var pg = paginas(track);
        var alvo = Number(b.dataset.flDot) * pg.passo * pg.por;
        track.scrollTo({ left: D.documentElement.dir === 'rtl' ? -alvo : alvo, behavior: REDUZ ? 'auto' : 'smooth' });
      });
    }
    atualizaRail(rail);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { atualizaRail(rail); });
    setTimeout(function () { atualizaRail(rail); }, 500);
  }
  function pintaRail(k) {
    var sec = $('[data-fl-sec="' + k + '"]');
    var l = lista(k);
    if (sec) sec.hidden = !l.length;
    if (k === 'offers') $$('[data-fl-offers-link]').forEach(function (li) { li.hidden = !l.length; });
    if (!l.length) return;
    var rail = $('[data-fl-rail="' + k + '"]');
    pinta($('[data-fl-grid="' + k + '"]', rail), l);
    ligaRail(rail);
  }

  /* ---------- "Do que seu cabelo sente falta?" -------------------------------------
     O cartao abre, logo abaixo, a vitrine daquela necessidade. Clicar de novo
     no mesmo cartao fecha. */
  var NEED = '';
  function produtosDaNecessidade(k) { return dispPrimeiro(daLista((CFG.needs || {})[k])); }
  function abreNecessidade(k, rolar) {
    var painel = $('[data-fl-need-panel]');
    if (!painel) return;
    var l = produtosDaNecessidade(k);
    if (!k || !l.length || (NEED === k && !rolar)) { fechaNecessidade(); return; }
    NEED = k;
    $$('[data-fl-need]').forEach(function (b) {
      var on = b.dataset.flNeed === k;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', String(on));
    });
    var tit = $('[data-fl-need-title]', painel);
    if (tit) tit.textContent = t('nd_' + k) + ' · ' + t('nd_count').replace('{n}', fmtNum(l.length));
    painel.hidden = false;
    var rail = $('[data-fl-rail="need"]', painel);
    var track = $('.fl-rail__track', rail);
    pinta(track, l);
    if (track) track.scrollLeft = 0;
    ligaRail(rail);
    if (rolar) painel.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'start' });
  }
  function fechaNecessidade() {
    NEED = '';
    var painel = $('[data-fl-need-panel]');
    if (painel) painel.hidden = true;
    $$('[data-fl-need]').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-selected', 'false'); });
  }
  function ligaNecessidades() {
    $$('[data-fl-need]').forEach(function (b) {
      b.hidden = !produtosDaNecessidade(b.dataset.flNeed).length;
    });
  }

  /* ---------- "Linhas Forever Liss" — a vitrine completa ---------------------------- */
  function linhas() {
    var usados = {};
    var out = (CFG.lines || []).map(function (ln) {
      var ps = daLista(ln.h);
      ps.forEach(function (p) { usados[p.h] = true; });
      return { k: ln.k, n: ln.n, ps: ps };
    });
    /* produto novo fora de qualquer linha: entra em "Mais linhas" */
    var sobra = PRODUCTS.filter(function (p) { return !usados[p.h]; });
    if (sobra.length) {
      var mais = out.filter(function (l) { return l.k === 'more'; })[0];
      if (mais) mais.ps = mais.ps.concat(sobra); else out.push({ k: 'more', n: '', ps: sobra });
    }
    return out.filter(function (l) { return l.ps.length; }).map(function (l) { l.ps = dispPrimeiro(l.ps); return l; });
  }
  function nomeLinha(l) { return l.k === 'more' ? t('ln_more') : l.n; }
  function pintaLinhas() {
    var box = $('[data-fl-lines]'), chips = $('[data-fl-line-chips]');
    if (!box) return;
    var ls = linhas();
    box.innerHTML = '';
    if (chips) chips.innerHTML = ls.map(function (l) {
      return '<a class="fl-chip" href="#fl-line-' + esc(l.k) + '">' + esc(nomeLinha(l)) + '</a>';
    }).join('');
    ls.forEach(function (l) {
      var sec = D.createElement('section');
      sec.className = 'fl-line';
      sec.id = 'fl-line-' + l.k;
      sec.setAttribute('aria-labelledby', 'fl-line-h-' + l.k);
      var d = t('ln_' + l.k + '_d');
      sec.innerHTML = '<div class="fl-line__head"><h3 class="fl-t fl-t--sm" id="fl-line-h-' + esc(l.k) + '">' + esc(nomeLinha(l)) +
        ' <small>' + esc(t('nd_count').replace('{n}', fmtNum(l.ps.length))) + '</small></h3>' +
        (d ? '<p>' + esc(d) + '</p>' : '') + '</div><div class="fl-grid" data-fl-grid="line-' + esc(l.k) + '"></div>';
      box.appendChild(sec);
      pinta($('.fl-grid', sec), l.ps);
    });
    box.setAttribute('aria-busy', 'false');
  }
  function irParaLinha(k) {
    var alvo = D.getElementById('fl-line-' + k);
    if (!alvo) return false;
    alvo.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'start' });
    return true;
  }

  /* ---------- vitrines ------------------------------------------------------------ */
  function renderGrids() {
    var vazio = !PRODUCTS.length;
    var painel = $('[data-fl-nostock]');
    if (painel) {
      if (vazio && !painel.childElementCount) { var tpl = $('[data-fl-nostock-tpl]'); if (tpl && tpl.content) painel.appendChild(tpl.content.cloneNode(true)); }
      painel.hidden = !vazio;
    }
    if (vazio) {
      $$('.fl-needs__row,[data-fl-sec],#fl-lines').forEach(function (s) { s.hidden = true; });
      return;
    }
    ['offers', 'news', 'best', 'kits'].forEach(pintaRail);
    ligaNecessidades();
    if (NEED) abreNecessidade(NEED, false);
    pintaLinhas();
    montaPopulares();
    /* atalhos para produto fora do mercado viram nada (link morto nao leva a lugar nenhum) */
    $$('.fl-foot [data-fl-open-handle]').forEach(function (a) { var li = a.closest('li'); if (li) li.hidden = !porHandle(a.dataset.flOpenHandle); });
  }

  /* ==========================================================================
     BANNER — carrossel de 4 slides. Troca sozinho a cada 6 s (menos com o
     mouse em cima, com foco dentro ou com "reduzir movimento" ligado).
     ========================================================================== */
  var HERO = { i: 0, n: 0, t: null, dur: 6000, pausa: false };
  function heroVai(k) {
    var hero = $('[data-fl-hero]');
    if (!hero) return;
    var slides = $$('[data-fl-slide]', hero);
    HERO.n = slides.length;
    HERO.i = (k + HERO.n) % HERO.n;
    slides.forEach(function (s, i) {
      var on = i === HERO.i;
      s.classList.toggle('is-on', on);
      if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      $$('a,button', s).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      /* as artes dos outros slides so baixam quando chega a vez delas */
      if (on) $$('img[loading="lazy"]', s).forEach(function (im) { im.loading = 'eager'; });
    });
    $$('[data-fl-hero-dot]', hero).forEach(function (b, i) { if (i === HERO.i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    heroAgenda();
  }
  function heroAgenda() {
    clearTimeout(HERO.t);
    if (REDUZ || HERO.pausa || HERO.n < 2) return;
    HERO.t = setTimeout(function () { heroVai(HERO.i + 1); }, HERO.dur);
  }
  function ligaHero() {
    var hero = $('[data-fl-hero]');
    if (!hero) return;
    var rtl = D.documentElement.dir === 'rtl';
    var prev = $('[data-fl-hero-prev]', hero), next = $('[data-fl-hero-next]', hero);
    if (prev) prev.addEventListener('click', function () { heroVai(HERO.i - 1); });
    if (next) next.addEventListener('click', function () { heroVai(HERO.i + 1); });
    $$('[data-fl-hero-dot]', hero).forEach(function (b) { b.addEventListener('click', function () { heroVai(Number(b.dataset.flHeroDot)); }); });
    hero.addEventListener('mouseenter', function () { HERO.pausa = true; heroAgenda(); });
    hero.addEventListener('mouseleave', function () { HERO.pausa = false; heroAgenda(); });
    hero.addEventListener('focusin', function () { HERO.pausa = true; heroAgenda(); });
    hero.addEventListener('focusout', function () { HERO.pausa = false; heroAgenda(); });
    /* arrastar com o dedo */
    var x0 = null, y0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      var ir = dx < 0 ? 1 : -1;
      if (rtl) ir = -ir;
      heroVai(HERO.i + ir);
    }, { passive: true });
    D.addEventListener('visibilitychange', function () { if (D.hidden) clearTimeout(HERO.t); else heroAgenda(); });
    heroVai(0);
  }

  /* ==========================================================================
     ENCAIXE DO TEXTO NAS ARTES — cada idioma escreve de um tamanho. Mede as
     caixas de texto de cada slide (tambem os escondidos: visibility:hidden
     mantem as medidas) e, se alguma encosta em outra ou sai da arte, baixa a
     letra aos poucos: primeiro a do titulo (--fl-kt), depois a do resto
     (--fl-k), no maximo ate 70%. Posicoes e larguras nao mudam.
     ========================================================================== */
  function caixasArte(art) {
    var els = [];
    $$(':scope > *', art).forEach(function (e) {
      if (e.classList.contains('fl-art__col') || e.classList.contains('fl-art__buy')) els = els.concat($$(':scope > *', e));
      else els.push(e);
    });
    return els.filter(function (e) { return e.getClientRects().length; });
  }
  function problemaArte(art) {
    var R = art.getBoundingClientRect(), els = caixasArte(art), tit = false, algum = false;
    if (!R.width) return null;
    var rs = els.map(function (e) { return e.getBoundingClientRect(); });
    function marca(i) { algum = true; if (/fl-art__(title|big)/.test(els[i].className)) tit = true; }
    for (var i = 0; i < rs.length; i++) {
      var a = rs[i];
      if (a.left < R.left - 1 || a.top < R.top - 1 || a.right > R.right + 1 || a.bottom > R.bottom - R.height * .02) marca(i);
      if (els[i].scrollWidth > els[i].clientWidth + 1) marca(i);
      for (var j = i + 1; j < rs.length; j++) {
        var b = rs[j];
        if (Math.min(a.right, b.right) - Math.max(a.left, b.left) > 2 && Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top) > 2) { marca(i); marca(j); }
      }
    }
    return algum ? { tit: tit } : null;
  }
  function ajustaArte() {
    $$('[data-fl-fit]').forEach(function (art) {
      var kt = 1, k = 1;
      art.style.removeProperty('--fl-kt'); art.style.removeProperty('--fl-k');
      for (var n = 0; n < 14; n++) {
        var p = problemaArte(art);
        if (!p) break;
        if (p.tit && kt > .71) kt = Math.round((kt - .05) * 100) / 100;
        else if (k > .71) k = Math.round((k - .04) * 100) / 100;
        else break;
        art.style.setProperty('--fl-kt', kt); art.style.setProperty('--fl-k', k);
      }
    });
  }
  function ligaEncaixe() {
    if (!$('[data-fl-fit]')) return;
    ajustaArte();
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(ajustaArte);
    var t, w = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === w) return;
      w = window.innerWidth; clearTimeout(t); t = setTimeout(ajustaArte, 200);
    });
  }

  /* ==========================================================================
     BUSCA — inteira no navegador, sobre o JSON ja baixado (nada de /search,
     que traria outras marcas para dentro da loja da Forever Liss).
     ========================================================================== */
  var buscaEl, buscaVeil, buscaInput, buscaRes, buscaSug, buscaNone, buscaT;
  function normal(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* motor antigo */ }
    return s;
  }
  function linhaDe(p) {
    var ls = CFG.lines || [];
    for (var i = 0; i < ls.length; i++) if ((ls[i].h || []).indexOf(p.h) > -1) return ls[i].n || '';
    return '';
  }
  function buscar(q) {
    var n = normal(q).trim();
    if (n.length < 2) return [];
    var termos = n.split(/\s+/);
    return PRODUCTS.filter(function (p) {
      /* o handle entra na busca: e em ingles e nao muda com o idioma */
      var alvo = normal(p.t) + ' ' + normal(curto(p)) + ' ' + normal(p.h.replace(/-/g, ' ')) + ' ' + normal(p.tags.join(' ')) + ' ' +
                 normal(linhaDe(p)) + ' ' + normal(t('cat_' + p.need)) + ' ' +
                 normal(p.v.map(function (v) { return v.sku || ''; }).join(' '));
      return termos.every(function (x) { return alvo.indexOf(x) > -1; });
    }).slice(0, 40);
  }
  function sresHTML(p) {
    var img = (p.img[0] || {}).s || '';
    return '<button type="button" class="fl-sres" data-fl-open-handle="' + esc(p.h) + '">' +
      '<span class="fl-sres__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span><b>' + esc(curto(p)) + '</b><span>' + precoHTML(p).replace(/<\/?b>/g, '').replace(/<\/?small>/g, '') + '</span></span></button>';
  }
  function montaPopulares() {
    var alvo = $('[data-fl-search-popular]');
    if (!alvo) return;
    alvo.innerHTML = daLista(CFG.best).filter(function (p) { return p.av; }).slice(0, 5).map(sresHTML).join('');
  }
  function pintaResultados(q) {
    if (!buscaRes) return;
    var l = buscar(q);
    var temTermo = normal(q).trim().length >= 2;
    if (buscaSug) buscaSug.hidden = temTermo;
    buscaRes.hidden = !temTermo;
    if (buscaNone) buscaNone.hidden = !(temTermo && !l.length);
    buscaRes.innerHTML = l.map(sresHTML).join('');
  }
  function abrirBusca(termo) {
    if (!buscaEl) return;
    fecharMenu();
    if (termo != null && buscaInput) { buscaInput.value = termo; pintaResultados(termo); }
    if (buscaEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    buscaEl.classList.add('is-on');
    buscaEl.setAttribute('aria-hidden', 'false');
    if (buscaVeil) { buscaVeil.hidden = false; requestAnimationFrame(function () { buscaVeil.classList.add('is-on'); }); }
    travarRolagem();
    if (buscaInput) setTimeout(function () { buscaInput.focus(); }, 60);
  }
  function fecharBusca() {
    if (!buscaEl || !buscaEl.classList.contains('is-on')) return;
    buscaEl.classList.remove('is-on');
    buscaEl.setAttribute('aria-hidden', 'true');
    if (buscaVeil) { buscaVeil.classList.remove('is-on'); setTimeout(function () { buscaVeil.hidden = true; }, 220); }
    destravarRolagem();
  }
  function ligaBusca() {
    buscaEl = $('[data-fl-search]');
    buscaVeil = $('[data-fl-search-veil]');
    buscaInput = $('[data-fl-search-input]');
    buscaRes = $('[data-fl-search-results]');
    buscaSug = $('[data-fl-search-suggest]');
    buscaNone = $('[data-fl-search-none]');
    if (!buscaEl || !buscaInput) return;
    buscaInput.addEventListener('input', function () {
      clearTimeout(buscaT);
      var v = buscaInput.value;
      buscaT = setTimeout(function () { pintaResultados(v); }, 120);
    });
    buscaInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(buscaT); pintaResultados(buscaInput.value); }
    });
  }

  /* ---------- menu do celular ------------------------------------------------------- */
  var menuEl, menuVeil;
  function abrirMenu() {
    if (!menuEl || menuEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    menuEl.classList.add('is-on');
    menuEl.setAttribute('aria-hidden', 'false');
    if (menuVeil) { menuVeil.hidden = false; requestAnimationFrame(function () { menuVeil.classList.add('is-on'); }); }
    travarRolagem();
    var x = $('[data-fl-menu-close]', menuEl);
    if (x) x.focus();
  }
  function fecharMenu() {
    if (!menuEl || !menuEl.classList.contains('is-on')) return;
    menuEl.classList.remove('is-on');
    menuEl.setAttribute('aria-hidden', 'true');
    if (menuVeil) { menuVeil.classList.remove('is-on'); setTimeout(function () { menuVeil.hidden = true; }, 220); }
    destravarRolagem();
  }

  /* ---------- cabecalho grudado: a altura vira variavel para as ancoras ---------- */
  function ligaCabecalho() {
    var head = $('[data-fl-head]');
    if (!head) return;
    function mede() {
      D.body.style.setProperty('--fl-hh', Math.round(head.getBoundingClientRect().height) + 'px');
    }
    mede();
    window.addEventListener('resize', mede);
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(mede);
    var pedido = false;
    window.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () { pedido = false; head.classList.toggle('is-stuck', window.scrollY > 40); });
    }, { passive: true });
  }

  /* ---------- paginas 2..N ----------------------------------------------------------
     Pelo ?view=forever-liss-data, que devolve SO o JSON. Tres tentativas com
     pausa crescente: um 502 do proprio Shopify ja tirou metade da vitrine da Prohall. */
  function buscaPagina(n, tentativa) {
    var url = (CFG.root || '') + '/pages/forever-liss?view=forever-liss-data&page=' + n;
    /* SEM "Accept: application/json": com esse cabecalho a Shopify ignora o
       ?view= e devolve o JSON nativo da pagina (medido na Gold Spell). */
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var j = JSON.parse(txt);
        if (!j || !j.products || !j.products.length) throw new Error('pagina vazia');
        return j.products;
      })
      .catch(function (err) {
        if (tentativa >= 3) { console.warn('[forever-liss] pagina ' + n + ' nao veio:', err.message); return []; }
        return new Promise(function (ok) { setTimeout(ok, 400 * tentativa); }).then(function () { return buscaPagina(n, tentativa + 1); });
      });
  }
  function carregarResto() {
    var total = Number(CFG.pages) || 1;
    if (total < 2 || !PRODUCTS.length) return Promise.resolve();
    var pedidos = [];
    for (var n = 2; n <= total; n++) pedidos.push(buscaPagina(n, 1));
    return Promise.all(pedidos).then(function (partes) {
      var vistos = {};
      PRODUCTS.forEach(function (p) { vistos[p.h] = true; });
      var novos = [];
      partes.forEach(function (l) { l.forEach(function (p) { if (p && p.h && !vistos[p.h]) { vistos[p.h] = true; novos.push(p); } }); });
      if (!novos.length) return;
      PRODUCTS = PRODUCTS.concat(prepara(novos));
      renderGrids();
      pintaClose(); pintaFiltros(); pintaCronoProntos();
    });
  }

  /* ---------- trava de rolagem ---------------------------------------------------------
     Trava o HTML e o body: com html{overflow-x:clip}, travar so o body deixava
     a roda do mouse rolar a LP por tras do popup (armadilha da Peach Up). */
  var travas = 0;
  function travarRolagem() { travas++; D.documentElement.classList.add('fl-lock'); D.body.classList.add('fl-lock'); }
  function destravarRolagem() {
    travas = Math.max(0, travas - 1);
    if (!travas) { D.documentElement.classList.remove('fl-lock'); D.body.classList.remove('fl-lock'); }
  }

  /* ---------- ficha do produto ---------------------------------------------------------- */
  var pdpOvl, pdpBox, lastFocus = null;
  var PDP = { p: null, v: null };
  var INFO = {};

  function linhasTxt(txt) { return String(txt || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean); }
  function bulletsHTML(txt) {
    var ls = linhasTxt(txt);
    if (!ls.length) return '';
    return ls.length > 1 ? '<ul>' + ls.map(function (l) { return '<li>' + esc(l.replace(/^[-•]\s*/, '')) + '</li>'; }).join('') + '</ul>' : '<p>' + esc(ls[0]) + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim();
      return l ? '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>' : '';
    }).join('');
  }
  /* "Ingredientes explicados": blocos separados por ---, NOME na primeira
     linha; linha comecando com ⚠ e aviso e ganha destaque proprio. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var ls = linhasTxt(bloco);
      if (!ls.length) return '';
      var nome = ls.shift();
      var aviso = ls.filter(function (x) { return /^⚠/.test(x); });
      var corpo = ls.filter(function (x) { return !/^⚠/.test(x); });
      return '<div class="fl-ing"><strong>' + esc(nome) + '</strong>' + esc(corpo.join(' ')) +
        (aviso.length ? '<span class="fl-warn">' + esc(aviso.join(' ')) + '</span>' : '') + '</div>';
    }).join('');
  }
  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="fl-acc"' + (open ? ' open' : '') + '><summary>' + esc(t(key)) + '</summary><div class="fl-acc__c">' + body + '</div></details>';
  }
  function degrauDe(total) {
    var at = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) at = s; });
    return at;
  }
  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="fl-pdp__qd" data-fl-pdp-qd><strong>' + esc(t('qd_t')) + '</strong><ul>' +
      passos.map(function (s) {
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(s.q >= 4 ? t('qd_4') : t('qd_' + s.q)) + '</span></li>';
      }).join('') + '</ul><small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small></div>';
  }
  function optHTML(p) {
    if (!p.multi) return '';
    var rotulo = p.opt && p.opt !== 'Title' ? p.opt : t('pdp_opt');
    return '<div class="fl-opt"><span class="fl-opt__l" id="fl-opt-l">' + esc(rotulo) + '</span>' +
      '<div class="fl-opt__list" role="group" aria-labelledby="fl-opt-l">' +
      p.v.map(function (v, i) {
        var c = por100(v), mb = melhorVar(p);
        return '<button type="button" class="fl-opt__b" data-fl-var="' + v.id + '" aria-pressed="' + (PDP.v && PDP.v.id === v.id) + '"' +
          (v.av ? '' : ' disabled') + '><span>' + esc(v.t) + '</span>' +
          (c ? '<small>' + esc(c.txt) + '</small>' : '') +
          (i === mb ? '<em>' + esc(t('sz_best')) + '</em>' : '') + '</button>';
      }).join('') + '</div></div>';
  }
  function pintarVariante() {
    var p = PDP.p, v = PDP.v;
    if (!p || !v) return;
    var preco = $('[data-fl-pdp-price]');
    var de = riscado(v);
    if (preco) preco.innerHTML = (de ? '<s>' + esc(de) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    var bdg = $('[data-fl-pdp-badges]');
    if (bdg) bdg.innerHTML = badgesHTML(p, v);
    var sku = $('[data-fl-pdp-sku]');
    if (sku) { sku.textContent = t('pdp_sku') + ': ' + (v.sku || '—'); sku.hidden = !v.sku; }
    $$('[data-fl-var]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.flVar) === Number(v.id))); });
    $$('[data-fl-add],[data-fl-buy]', pdpBox).forEach(function (b) {
      var ehAdd = b.hasAttribute('data-fl-add');
      if (ehAdd) b.dataset.flAdd = v.id; else b.dataset.flBuy = v.id;
      b.disabled = !v.av;
      b.textContent = v.av ? (ehAdd ? t('add') : t('buy')) : t('soldout');
    });
    var qty = $('.fl-pdp__qty');
    if (qty) qty.hidden = !v.av;
    marcarDegrausPDP();
  }

  var PDP_QTD_MAX = 10;
  function qtdHTML() {
    return '<div class="fl-pdp__qty"><span class="fl-pdp__qty-l" id="fl-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="fl-step fl-step--lg" role="group" aria-labelledby="fl-pdp-qty-l">' +
      '<button type="button" data-fl-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
      '<span data-fl-pdp-qtd aria-live="polite">1</span>' +
      '<button type="button" data-fl-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button></span></div>';
  }
  function pdpQtd() {
    var el = $('[data-fl-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }
  function porQtdPDP(n) {
    var el = $('[data-fl-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-fl-pdp-step="-1"]'), mais = $('[data-fl-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
  }
  /* O Pumper conta o carrinho INTEIRO: acende o degrau do que o carrinho VAI
     ter depois de somar a quantidade escolhida aqui. */
  function marcarDegrausPDP() {
    var caixa = $('[data-fl-pdp-qd]');
    if (!caixa) return;
    var at = degrauDe(CART.count + pdpQtd());
    $$('li', caixa).forEach(function (li) { li.classList.toggle('is-on', !!at && Number(li.dataset.q) === at.q); });
  }
  /* O que abre o popup da garantia, de qualquer lugar: <label for>, nunca um
     link para outra guia (quem sai da LP perde o carrinho de vista). */
  function abreGarantia(rotulo) {
    return '<label class="fl-lnk" for="fl-guar-cbx" role="button" tabindex="0">' + esc(t(rotulo)) + '</label>';
  }
  function entregaHTML() {
    return '<div class="fl-pdp__del">' + SELO + '<div><b>' + esc(t('del_t')) + '</b><p>' + esc(t('del_pdp')) + '</p>' + abreGarantia('del_c') + '</div></div>';
  }
  /* A parte pesada da ficha: descricao completa + resumo por IA, pelo
     ?view=forever-liss-info. Se falhar, cai para o /products/<h>.js. */
  function carregaInfo(h) {
    if (INFO[h]) return Promise.resolve(INFO[h]);
    var base = (CFG.root || '') + '/products/' + encodeURIComponent(h);
    return fetch(base + '?view=forever-liss-info', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) { return JSON.parse(txt); })
      .catch(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { return { ai: {}, d: j.description || '' }; });
      })
      .then(function (info) { INFO[h] = info || { ai: {}, d: '' }; return INFO[h]; })
      .catch(function () { return { ai: {}, d: '' }; });
  }
  function pintaInfo(p, info) {
    var alvo = $('[data-fl-pdp-more]');
    if (!alvo || !PDP.p || PDP.p.h !== p.h) return;
    var ai = info.ai || {};
    var tag = $('[data-fl-pdp-tag]');
    if (tag) { tag.textContent = ai.tag || ''; tag.hidden = !ai.tag; }
    alvo.innerHTML =
      acc('pdp_purpose', bulletsHTML(ai.pur), true) +
      acc('pdp_high', bulletsHTML(ai.hig)) +
      acc('pdp_how', parasHTML(ai.how)) +
      acc('pdp_audience', parasHTML(ai.aud)) +
      acc('pdp_good', bulletsHTML(ai.gtk)) +
      acc('pdp_ing', ingHTML(ai.ing)) +
      acc('pdp_tog', parasHTML(ai.tog)) +
      (info.d ? '<details class="fl-acc"' + (ai.pur ? '' : ' open') + '><summary>' + esc(t('pdp_desc')) + '</summary><div class="fl-acc__c fl-desc">' + info.d + '</div></details>' : '') +
      (info.note ? '<p class="fl-legal">' + esc(info.note) + '</p>' : '');
  }
  function openPDP(handle) {
    var p = porHandle(handle);
    if (!p || !pdpOvl) return false;
    fecharMenu();
    if (!pdpOvl.classList.contains('is-on')) lastFocus = D.activeElement;
    PDP.p = p;
    PDP.v = p.min; /* abre na variante disponivel mais barata, nunca numa esgotada */
    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-fl-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') + ' aria-label="' + (i + 1) + '/' + p.img.length + '">' +
        '<img src="' + esc(imgW(im.s, 120)) + '" alt="" loading="lazy"></button>';
    }).join('');
    var im0 = p.img[0] || {};
    var ln = linhaDe(p);
    pdpBox.innerHTML =
      '<button type="button" class="fl-x" data-fl-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="fl-pdp">' +
        '<div class="fl-pdp__gal">' +
          '<div class="fl-pdp__main">' + (im0.s ? '<img src="' + esc(imgW(im0.s, 900)) + '" alt="' + esc(im0.a || p.t) + '" width="900" height="900" data-fl-main>' : '') + '</div>' +
          (p.img.length > 1 ? '<div class="fl-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="fl-pdp__info">' +
          '<p class="fl-pdp__brand">Forever Liss' + (ln ? ' · ' + esc(ln) : '') + ' · ' + esc(t('official')) + '</p>' +
          (p.need && t('cat_' + p.need) ? '<span class="fl-card__need fl-card__need--pdp">' + esc(t('cat_' + p.need)) + '</span>' : '') +
          '<h2 id="fl-pdp-t">' + esc(p.t) + '</h2>' +
          starsHTML(p) +
          '<p class="fl-pdp__tag" data-fl-pdp-tag hidden></p>' +
          '<div class="fl-pdp__badges" data-fl-pdp-badges></div>' +
          '<div class="fl-pdp__price" data-fl-pdp-price></div>' +
          optHTML(p) + qtdHTML() + qdHTML() +
          '<div class="fl-pdp__acts">' +
            '<button type="button" class="fl-btn fl-btn--ghost" data-fl-add=""></button>' +
            '<button type="button" class="fl-btn fl-btn--buy" data-fl-buy=""></button>' +
          '</div>' +
          entregaHTML() +
          '<div data-fl-pdp-more><div class="fl-skel" aria-hidden="true"><i></i><i></i><i></i></div></div>' +
          '<p class="fl-nota" style="margin:0" data-fl-pdp-sku></p>' +
        '</div>' +
      '</div>';
    if (!pdpOvl.classList.contains('is-on')) { pdpOvl.classList.add('is-on'); travarRolagem(); }
    pdpOvl.scrollTop = 0; pdpBox.scrollTop = 0;
    porQtdPDP(1);
    pintarVariante();
    var x = $('[data-fl-pdp-close]', pdpBox);
    if (x) x.focus();
    carregaInfo(p.h).then(function (info) { pintaInfo(p, info); });
    return true;
  }
  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    PDP.p = null; PDP.v = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ------------------------------------------------------------------- */
  var CART = { items: [], total: 0, count: Number((CFG.cart || {}).count) || 0, raw: null };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl;

  /* Recado de frete CALCULADO por window.MKPBR_SHIP (a mesma conta da barra
     da loja) e escrito dentro do carrinho. */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) { shipEl.hidden = true; return; }
    var e;
    try { e = S.compute(CART.raw); } catch (err) { console.error('[forever-liss] frete', err); shipEl.hidden = true; return; }
    if (!e) { shipEl.hidden = true; return; }
    if (e.freeReached) shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      shipEl.innerHTML = '<b>' + esc(t('ship_more').replace('{v}', money(Math.round(e.faltaProximo * 100))).replace('{p}', money(Math.round(e.economiaProximo * 100)))) + '</b>';
    } else { shipEl.hidden = true; return; }
    shipEl.hidden = false;
  }
  function cartURL(path) { return (CFG.root || '') + path; }
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }
  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); return c; })
      .catch(function (e) { console.error('[forever-liss] cart.js', e); });
  }
  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* a barra de frete da loja so aparece DEPOIS que existe carrinho */
    D.body.classList.toggle('fl-has-cart', CART.count > 0);
    renderCart();
    markStep();
  }
  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML = '<div class="fl-cart__empty"><strong>' + esc(t('c_empty')) + '</strong><span>' + esc(t('c_empty_d')) + '</span>' +
        '<button type="button" class="fl-btn fl-btn--ghost fl-btn--sm" data-fl-cart-close>' + esc(t('c_empty_cta')) + '</button></div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? imgW(it.image, 160) : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="fl-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="fl-cline" data-key="' + esc(it.key) + '">' +
        '<div class="fl-cline__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><span class="fl-cline__t">' + esc(curtoLinha(it)) + '</span>' + vt +
          '<div class="fl-cline__r"><span class="fl-step">' +
            '<button type="button" data-fl-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-fl-qty="1" aria-label="' + esc(t('c_more')) + '">+</button></span>' +
            '<span class="fl-cline__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span></div>' +
          '<button type="button" class="fl-cline__x" data-fl-rm>' + esc(t('c_rm')) + '</button>' +
        '</div></div>';
    }).join('');
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
  }
  function markStep() {
    var at = degrauDe(CART.count);
    marcarDegrausPDP();
    if (qdEl) {
      if (at) {
        qdEl.textContent = (at.q >= 4 ? t('qd_4') : t('qd_' + at.q)) + ' · ' + at.p + '% ' + t('off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else qdEl.hidden = true;
    }
    espelharFrete();
  }
  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    fecharMenu();
    lastFocus = D.activeElement;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    espelharFrete();
    var c = $('[data-fl-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus && !pdpOvl.classList.contains('is-on')) lastFocus.focus();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-fl-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  function addToCart(vid, abrir, btn, qtd) {
    if (!vid) return;
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var doCard = btn && btn.classList.contains('fl-card__add');
    var rotulo = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); if (!doCard) btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          if (doCard) { btn.classList.add('is-done'); var s = $('span', btn); if (s) s.textContent = t('added'); setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = rotulo; }, 1400); }
          else { btn.textContent = t('added'); setTimeout(function () { btn.innerHTML = rotulo; }, 1400); }
        }
        porQtdPDP(1);
        /* card e "adicionar" NAO abrem o carrinho; "comprar agora" abre */
        if (abrir) { closePDP(); openCart(); } else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[forever-liss] add', e);
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = rotulo; }
        toast(t('err_add'));
      });
  }
  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(aplicarCarrinho)
      .catch(function (e) { console.error('[forever-liss] change', e); });
  }

  /* ---------- seletores de pais e idioma ---------------------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.fl-pick__btn', wrap), menu = $('.fl-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharMenus();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var atual = $('[aria-current="true"]', menu);
      if (atual) atual.scrollIntoView({ block: 'nearest' });
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharMenus() {
    $$('.fl-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.fl-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  /* O pais prefere a janela do app Orbe; a lista nativa fica de reserva.
     mdApp_forceHideOrbe so trava o pop-up AUTOMATICO. */
  function tentarOrbe() {
    try {
      var modal = D.getElementById('md-app-embed__footer-popup');
      if (typeof window.mdApp_openModal === 'function' && modal) { window.mdApp_openModal('md-app-embed__footer-popup'); return true; }
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }
  function abrirPais() {
    if (tentarOrbe()) return;
    var btn = $('[data-fl-country] .fl-pick__btn');
    if (btn) { window.scrollTo(0, 0); btn.click(); }
  }

  /* ---------- faixa de divergencia de mercado --------------------------------------------
     Sinal: regiao do idioma do navegador; na falta, o fuso. SEM SINAL, NAO
     APARECE. So na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Asia/Qatar': 'QA', 'Asia/Kuwait': 'KW', 'Asia/Bahrain': 'BH', 'Asia/Muscat': 'OM',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone; if (tz && TZ2CC[tz]) return TZ2CC[tz]; } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-fl-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('fl-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = String(CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;
    var form = D.getElementById('fl-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */
    var nome = $('span', alvo);
    var nomeEl = $('[data-fl-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-fl-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-fl-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('fl-hint-off', '1'); } catch (e) { /* so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ==========================================================================
     v2 (23/09/2026) — o que o site oficial NAO tem
     Quatro recursos, todos montados com o que o Liquid ja entregou (#fl-data)
     e com as listas de #fl-cfg ("v2"): quiz "Descubra sua rotina", "Monte seu
     cronograma capilar", mosaico "Visto de perto" e os atalhos da vitrine.
     Nenhuma afirmacao nova sobre os produtos: nomes, tamanhos, tags e fotos
     sao os do cadastro; o texto de cada linha e o que a marca diz dela.
     ========================================================================== */
  var V2 = CFG.v2 || {};

  /* ---------- tamanho da variante e preco por 100 g/ml ----------------------
     O tamanho esta no NOME da variante ("250g", "1kg", "300ml", "1L"). O preco
     por 100 e conta em cima do preco do mercado — nada vem escrito a mao. */
  function medida(v) {
    var s = String((v && v.t) || '').toLowerCase().replace(',', '.').replace(/\s+/g, '');
    var m = /([\d.]+)(kg|g|ml|l)\b/.exec(s) || /([\d.]+)(kg|g|ml|l)$/.exec(s);
    if (!m) return null;
    var q = parseFloat(m[1]), u = m[2];
    if (!isFinite(q) || q <= 0) return null;
    if (u === 'kg') { q *= 1000; u = 'g'; }
    if (u === 'l') { q *= 1000; u = 'ml'; }
    return { q: q, u: u };
  }
  function por100(v) {
    var md = medida(v);
    if (!md || !isFinite(v.pr)) return null;
    return { val: v.pr / md.q, txt: t('sz_per').replace('{m}', money(Math.round(v.pr * 100 / md.q))).replace('{u}', md.u) };
  }
  /* indice da variante que sai mais em conta por 100 g/ml (so com 2+ medidas) */
  function melhorVar(p) {
    var best = -1, bv = Infinity, n = 0;
    (p.v || []).forEach(function (v, i) {
      var c = por100(v);
      if (!c) return;
      n++;
      if (c.val < bv - 0.000001) { bv = c.val; best = i; }
    });
    return n > 1 ? best : -1;
  }
  function temTamanhos(p) { return !!(p && p.v && p.v.length > 1 && medida(p.v[0])); }
  /* foto da galeria pelo pedaco do NOME DO ARQUIVO (nao muda com o idioma) */
  function fotoDe(p, frag) {
    if (!p || !frag) return null;
    for (var i = 0; i < p.img.length; i++) if (String(p.img[i].s).indexOf(frag) > -1) return p.img[i];
    return null;
  }
  function varPorId(p, id) {
    if (!p || !id) return null;
    for (var i = 0; i < p.v.length; i++) if (String(p.v[i].id) === String(id)) return p.v[i];
    return null;
  }

  /* ---------- cartao pequeno, usado no quiz e no cronograma ------------------
     Foto, nome, preco e — quando o produto tem mais de um tamanho — os
     tamanhos com o preco por 100 g/ml. A pagina NUNCA escolhe o tamanho pela
     pessoa: sem escolha, o botao de adicionar fica travado. */
  function miniHTML(p, sel, ctx) {
    var v = varPorId(p, sel) || (temTamanhos(p) ? null : p.min);
    var img = p.img[0] || {};
    var mb = melhorVar(p);
    var chips = '';
    if (temTamanhos(p)) {
      /* pastilha so com o tamanho (nome curto); o preco e o preco por 100 g/ml
         do tamanho ESCOLHIDO ficam na linha de preco, para a caixa nao virar
         uma coluna de 7 linhas no produto com 7 tamanhos */
      chips = '<div class="fl-mini__sizes" role="group" aria-label="' + esc(t('cr_size')) + '">' +
        p.v.map(function (x, i) {
          return '<button type="button" class="fl-sz' + (v && v.id === x.id ? ' is-on' : '') + (i === mb ? ' fl-sz--best' : '') +
            '" data-fl-pick-size="' + x.id + '" data-fl-ctx="' + esc(ctx || '') + '"' +
            (x.av ? '' : ' disabled') + ' aria-pressed="' + !!(v && v.id === x.id) + '"' +
            (i === mb ? ' title="' + esc(t('sz_best')) + '"' : '') + '>' + esc(x.t) + '</button>';
        }).join('') + '</div>';
    }
    var c100 = v ? por100(v) : null;
    return '<div class="fl-mini" data-fl-mini="' + esc(p.h) + '">' +
      '<img class="fl-mini__img" src="' + esc(imgW(img.s || '', 300)) + '" alt="" loading="lazy" width="300" height="300">' +
      '<div class="fl-mini__b"><h4>' + esc(curto(p)) + '</h4>' +
      '<p class="fl-mini__p">' + (v ? '<bdi>' + esc(v.prf) + '</bdi>' + (c100 ? ' <small><bdi>' + esc(c100.txt) + '</bdi>' + (melhorVar(p) > -1 && p.v[melhorVar(p)].id === v.id ? ' · ' + esc(t('sz_best')) : '') + '</small>' : '') : esc(t('cr_size'))) + '</p>' +
      chips + '</div></div>';
  }

  /* ---------- adicionar varios itens de uma vez ------------------------------ */
  function addVarios(ids, btn) {
    if (!ids.length) return;
    var rot = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = rot; }
        openCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = rot; }
        toast(t('err_add'));
      });
  }

  /* ---------- quiz: Descubra sua rotina ------------------------------------- */
  var QZ = { t: null, p: null, q: null, passo: 0, sel: {} };
  function quizPerguntas() {
    return [
      { k: 't', q: 'qz_1q', d: '', o: [['a', 'qz_1a'], ['b', 'qz_1b'], ['c', 'qz_1c'], ['d', 'qz_1d']] },
      { k: 'p', q: 'qz_2q', d: '', o: [['a', 'qz_2a'], ['b', 'qz_2b'], ['c', 'qz_2c'], ['d', 'qz_2d'], ['e', 'qz_2e'], ['f', 'qz_2f']] },
      { k: 'q', q: 'qz_3q', d: 'qz_3d', o: [['y', 'qz_3y'], ['n', 'qz_3n']] }
    ];
  }
  function receita() {
    var qz = V2.quiz || {}, map = qz.map || {}, k = map[QZ.p];
    var chave = Array.isArray(k) ? ((QZ.t === 'c' || QZ.t === 'd') ? k[1] : k[0]) : k;
    var L = (qz.lines || {})[chave] || { items: [] };
    var extra = (chave === 'sos' || chave === 'cauter') ? qz.recon2 : qz.recon;
    var comQ = QZ.q === 'y' && extra && (L.items || []).indexOf(extra) < 0;
    var hs = (L.items || []).slice(0, comQ ? 3 : 4);
    if (comQ) hs.push(extra);
    var ps = hs.map(porHandle).filter(function (p) { return p && p.av; }).slice(0, 4);
    return { k: chave, go: L.go || '', ps: ps, extra: comQ && ps.length > 1 };
  }
  function pintaQuiz() {
    var box = $('[data-fl-quiz-box]');
    if (!box) return;
    var qs = quizPerguntas();
    if (QZ.passo < qs.length) {
      var p = qs[QZ.passo];
      box.innerHTML = '<div class="fl-quiz__step">' +
        '<p class="fl-quiz__n">' + esc(t('qz_s').replace('{n}', fmtNum(QZ.passo + 1))) + '</p>' +
        '<h3>' + esc(t(p.q)) + '</h3>' + (p.d ? '<p class="fl-quiz__d">' + esc(t(p.d)) + '</p>' : '') +
        '<div class="fl-quiz__opts">' + p.o.map(function (o) {
          return '<button type="button" class="fl-quiz__o" data-fl-qz="' + p.k + ':' + o[0] + '">' + esc(t(o[1])) + '</button>';
        }).join('') + '</div>' +
        (QZ.passo ? '<button type="button" class="fl-lnk" data-fl-qz-back>' + esc(t('qz_back')) + '</button>' : '') +
        '</div>';
      return;
    }
    var r = receita();
    if (!r.ps.length) {
      box.innerHTML = '<div class="fl-quiz__res"><p>' + esc(t('fi_none')) + '</p>' +
        '<button type="button" class="fl-lnk" data-fl-qz-redo>' + esc(t('qz_redo')) + '</button></div>';
      return;
    }
    QZ.sel = {};
    r.ps.forEach(function (p) { if (!temTamanhos(p)) QZ.sel[p.h] = p.min.id; });
    box.innerHTML = '<div class="fl-quiz__res">' +
      '<p class="fl-quiz__n">' + esc(t('qz_rt')) + '</p>' +
      '<h3>' + esc(t('r_' + r.k + '_t')) + '</h3>' +
      '<p class="fl-quiz__d">' + esc(t('r_' + r.k + '_d')) + '</p>' +
      (r.extra ? '<p class="fl-quiz__plus">' + esc(t('qz_plus')) + '</p>' : '') +
      '<div class="fl-quiz__list" data-fl-qz-list>' + r.ps.map(function (p) { return miniHTML(p, QZ.sel[p.h], 'qz'); }).join('') + '</div>' +
      '<p class="fl-quiz__d">' + esc(t('qz_rd')) + '</p>' +
      '<div class="fl-quiz__act">' +
        '<button type="button" class="fl-btn fl-btn--buy" data-fl-qz-add>' + esc(t('qz_add')) + '</button>' +
        (r.go ? '<a class="fl-btn fl-btn--ghost" href="#fl-lines" data-fl-line-go="' + esc(r.go) + '">' + esc(t('qz_see')) + '</a>' : '') +
        '<button type="button" class="fl-lnk" data-fl-qz-redo>' + esc(t('qz_redo')) + '</button>' +
      '</div></div>';
    marcaQuizAdd();
  }
  function marcaQuizAdd() {
    var bt = $('[data-fl-qz-add]');
    if (!bt) return;
    var r = receita();
    var falta = r.ps.some(function (p) { return !QZ.sel[p.h]; });
    bt.disabled = falta;
    bt.textContent = falta ? t('cr_size') : t('qz_add');
  }
  function ligaQuiz() {
    var sec = $('[data-fl-quiz]');
    if (!sec) return;
    pintaQuiz();
    sec.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-fl-qz],[data-fl-qz-back],[data-fl-qz-redo],[data-fl-qz-add],[data-fl-pick-size]') : null;
      if (!b) return;
      if (b.hasAttribute('data-fl-qz')) {
        var par = b.dataset.flQz.split(':');
        QZ[par[0]] = par[1];
        QZ.passo++;
        pintaQuiz();
      } else if (b.hasAttribute('data-fl-qz-back')) {
        QZ.passo = Math.max(0, QZ.passo - 1);
        pintaQuiz();
      } else if (b.hasAttribute('data-fl-qz-redo')) {
        QZ = { t: null, p: null, q: null, passo: 0, sel: {} };
        pintaQuiz();
      } else if (b.hasAttribute('data-fl-pick-size') && b.dataset.flCtx === 'qz') {
        var mini = b.closest('[data-fl-mini]');
        if (!mini) return;
        QZ.sel[mini.dataset.flMini] = b.dataset.flPickSize;
        var p = porHandle(mini.dataset.flMini);
        if (p) mini.outerHTML = miniHTML(p, QZ.sel[p.h], 'qz');
        marcaQuizAdd();
      } else if (b.hasAttribute('data-fl-qz-add')) {
        var rr = receita();
        var ids = rr.ps.map(function (p) { return QZ.sel[p.h]; }).filter(Boolean);
        addVarios(ids, b);
      }
    });
  }

  /* ---------- cronograma capilar --------------------------------------------
     Quatro etapas (hidratacao, nutricao, reconstrucao e finalizacao), cada uma
     com os produtos que a PROPRIA marca poe nessa etapa. A conta do desconto
     segue o Pumper: conta o carrinho inteiro. */
  var CR = { sel: {}, etapa: null };
  function etapas() { return (V2.crono && V2.crono.steps) || []; }
  function prodsEtapa(k) {
    return (((V2.crono || {})[k]) || []).map(porHandle).filter(function (p) { return p && p.av; });
  }
  function crEscolhidos() {
    return etapas().map(function (k) { return CR.sel[k]; }).filter(function (x) { return x && x.h; });
  }
  function crIds() {
    return crEscolhidos().map(function (x) { return x.id; }).filter(Boolean);
  }
  function pintaCrono() {
    var slots = $('[data-fl-crono-slots]');
    if (!slots) return;
    var passos = CFG.steps || [];
    slots.innerHTML = etapas().map(function (k, i) {
      var sel = CR.sel[k], p = sel && porHandle(sel.h);
      var passo = i > 0 ? passos[Math.min(i - 1, passos.length - 1)] : null;
      var cab = '<div class="fl-slot__h"><span class="fl-slot__n">' + esc(t('cr_step')) + ' ' + fmtNum(i + 1) + '</span>' +
        '<strong>' + esc(t('cr_' + k)) + '</strong><small>' + esc(t('cr_' + k + '_d')) + '</small></div>';
      if (!p) {
        return '<div class="fl-slot" data-fl-slot="' + k + '">' + cab +
          '<button type="button" class="fl-slot__add" data-fl-slot-open="' + k + '">' +
          '<span class="fl-slot__plus" aria-hidden="true">+</span>' + esc(t('cr_pick')) +
          (passo ? '<small>' + esc(t('cr_unlock').replace('{p}', passo.p)) + '</small>' : '') + '</button></div>';
      }
      return '<div class="fl-slot is-on" data-fl-slot="' + k + '">' + cab +
        miniHTML(p, sel.id, 'cr:' + k) +
        '<div class="fl-slot__act"><button type="button" class="fl-lnk" data-fl-slot-open="' + k + '">' + esc(t('cr_change')) + '</button>' +
        '<button type="button" class="fl-lnk" data-fl-slot-rm="' + k + '">' + esc(t('cr_remove')) + '</button></div></div>';
    }).join('');
    pintaCronoSoma();
  }
  function pintaCronoSoma() {
    var box = $('[data-fl-crono-sum]');
    if (!box) return;
    var esc_ = esc;
    var itens = crEscolhidos();
    var comTam = itens.filter(function (x) { return x.id; });
    var sub = comTam.reduce(function (a, x) {
      var p = porHandle(x.h), v = varPorId(p, x.id);
      return a + (v ? v.pr : 0);
    }, 0);
    var n = itens.length + (CART.count || 0);
    var passo = degrauDe(n);
    var passos = CFG.steps || [];
    var prox = null;
    for (var i = 0; i < passos.length; i++) if (n < passos[i].q) { prox = passos[i]; break; }
    var desc = passo ? Math.round(sub * passo.p / 100) : 0;
    var falta = itens.length && prox ? '<p class="fl-crsum__miss">' + esc_(t('cr_missing').replace('{n}', fmtNum(prox.q - n)).replace('{p}', prox.p)) + '</p>' : '';
    var travado = itens.some(function (x) { return !x.id; });
    if (!itens.length) { box.innerHTML = ''; return; }
    /* em arabe/hebraico o valor vai isolado (bdi): sem isso o sinal de menos
       pula para o outro lado do numero */
    box.innerHTML = '<div class="fl-crsum">' +
      '<div class="fl-crsum__l"><span>' + esc_(t('cr_sub')) + '</span><b data-fl-crsum-sub><bdi>' + esc_(money(sub)) + '</bdi></b></div>' +
      (passo ? '<div class="fl-crsum__l fl-crsum__l--d"><span>' + esc_(t('cr_disc')) + ' (' + passo.p + '%)</span><b><bdi>−' + esc_(money(desc)) + '</bdi></b></div>' : '') +
      '<div class="fl-crsum__l fl-crsum__l--t"><span>' + esc_(t('cr_tot')) + '</span><b><bdi>' + esc_(money(sub - desc)) + '</bdi></b></div>' +
      falta +
      '<button type="button" class="fl-btn fl-btn--buy fl-btn--full" data-fl-crono-add' + (travado ? ' disabled' : '') + '>' +
      esc_(travado ? t('cr_size') : t('cr_add')) + '</button></div>';
  }
  function pintaCronoProntos() {
    var box = $('[data-fl-crono-ready]');
    if (!box) return;
    var rs = (V2.crono && V2.crono.ready) || [];
    var html = rs.map(function (r) {
      var ps = Object.keys(r.i).map(function (k) { return porHandle(r.i[k]); }).filter(function (p) { return p && p.av; });
      if (ps.length < 2) return '';
      var fotos = ps.slice(0, 4).map(function (p) {
        return '<img src="' + esc(imgW((p.img[0] || {}).s || '', 150)) + '" alt="" loading="lazy" width="80" height="80">';
      }).join('');
      return '<button type="button" class="fl-ready" data-fl-ready="' + esc(r.k) + '"><span class="fl-ready__i">' + fotos + '</span>' +
        '<span class="fl-ready__t">' + esc(t('cr_' + r.k)) + '</span></button>';
    }).join('');
    box.innerHTML = html ? '<p class="fl-ready__l">' + esc(t('cr_ready')) + '</p><div class="fl-ready__row">' + html + '</div>' : '';
  }
  function aplicaPronto(k) {
    var r = ((V2.crono && V2.crono.ready) || []).filter(function (x) { return x.k === k; })[0];
    if (!r) return;
    CR.sel = {};
    Object.keys(r.i).forEach(function (et) {
      var p = porHandle(r.i[et]);
      if (!p || !p.av) return;
      CR.sel[et] = { h: p.h, id: temTamanhos(p) ? null : p.min.id };
    });
    pintaCrono();
    var sec = $('[data-fl-crono-slots]');
    if (sec) sec.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'center' });
  }
  function abrePick(etapa) {
    var dr = $('[data-fl-pick]'), body = $('[data-fl-pick-body]'), ttl = $('[data-fl-pick-t]');
    if (!dr) return;
    CR.etapa = etapa;
    if (ttl) ttl.textContent = t('cr_dr_t').replace('{s}', t('cr_' + etapa));
    if (body) {
      var ps = prodsEtapa(etapa);
      body.innerHTML = ps.length ? ps.map(function (p) {
        var sel = CR.sel[etapa] && CR.sel[etapa].h === p.h ? CR.sel[etapa].id : null;
        return '<div class="fl-pickrow">' + miniHTML(p, sel, 'pk') +
          '<button type="button" class="fl-btn fl-btn--sm" data-fl-pick-use="' + esc(p.h) + '">' + esc(t('cr_pick')) + '</button></div>';
      }).join('') : '<p class="fl-search__none">' + esc(t('fi_none')) + '</p>';
    }
    lastFocus = D.activeElement;
    dr.classList.add('is-on');
    dr.setAttribute('aria-hidden', 'false');
    var veil = $('[data-fl-pick-veil]');
    if (veil) { veil.hidden = false; requestAnimationFrame(function () { veil.classList.add('is-on'); }); }
    travarRolagem();
    var c = $('[data-fl-pick-close]', dr);
    if (c) c.focus();
  }
  function fechaPick() {
    var dr = $('[data-fl-pick]');
    if (!dr || !dr.classList.contains('is-on')) return;
    dr.classList.remove('is-on');
    dr.setAttribute('aria-hidden', 'true');
    var veil = $('[data-fl-pick-veil]');
    if (veil) { veil.classList.remove('is-on'); setTimeout(function () { veil.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function ligaCrono() {
    var sec = $('[data-fl-crono]');
    if (!sec) return;
    if (!etapas().length) { sec.hidden = true; return; }
    pintaCronoProntos();
    pintaCrono();
    sec.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-fl-slot-open],[data-fl-slot-rm],[data-fl-ready],[data-fl-crono-add],[data-fl-pick-size]') : null;
      if (!b) return;
      if (b.hasAttribute('data-fl-slot-open')) abrePick(b.dataset.flSlotOpen);
      else if (b.hasAttribute('data-fl-slot-rm')) { delete CR.sel[b.dataset.flSlotRm]; pintaCrono(); }
      else if (b.hasAttribute('data-fl-ready')) aplicaPronto(b.dataset.flReady);
      else if (b.hasAttribute('data-fl-crono-add')) addVarios(crIds(), b);
      else if (b.hasAttribute('data-fl-pick-size')) {
        var ctx = String(b.dataset.flCtx || '');
        if (ctx.indexOf('cr:') !== 0) return;
        var et = ctx.slice(3);
        if (CR.sel[et]) { CR.sel[et].id = b.dataset.flPickSize; pintaCrono(); }
      }
    });
    var dr = $('[data-fl-pick]');
    if (dr) dr.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-fl-pick-use],[data-fl-pick-close],[data-fl-pick-size]') : null;
      if (!b) return;
      if (b.hasAttribute('data-fl-pick-close')) { fechaPick(); return; }
      if (b.hasAttribute('data-fl-pick-size')) {
        var mini = b.closest('[data-fl-mini]');
        if (!mini) return;
        var p0 = porHandle(mini.dataset.flMini);
        if (!p0) return;
        mini.outerHTML = miniHTML(p0, b.dataset.flPickSize, 'pk');
        return;
      }
      var h = b.dataset.flPickUse, p = porHandle(h);
      if (!p) return;
      var row = b.closest('.fl-pickrow');
      var on = row ? $('.fl-sz.is-on', row) : null;
      var id = on ? on.dataset.flPickSize : (temTamanhos(p) ? null : p.min.id);
      CR.sel[CR.etapa] = { h: h, id: id };
      pintaCrono();
      fechaPick();
    });
    var veil = $('[data-fl-pick-veil]');
    if (veil) veil.addEventListener('click', fechaPick);
  }

  /* ---------- "Visto de perto": fotos da galeria dos produtos ---------------- */
  var CLOSE_ABERTO = false;
  function pintaClose() {
    var box = $('[data-fl-close]'), bt = $('[data-fl-close-more]');
    if (!box) return;
    var lista = (V2.tiles || []).map(function (x) {
      var p = porHandle(x.h);
      if (!p || !p.av) return null;
      var im = fotoDe(p, x.k);
      return im ? { p: p, im: im } : null;
    }).filter(Boolean);
    var sec = box.closest('section');
    if (lista.length < 6) { if (sec) sec.hidden = true; return; }
    if (sec) sec.hidden = false;
    var lim = window.matchMedia('(max-width:767px)').matches ? 9 : 15;
    var mostra = CLOSE_ABERTO ? lista : lista.slice(0, lim);
    box.innerHTML = mostra.map(function (x, i) {
      return '<a class="fl-cl' + (i < 2 ? ' fl-cl--big' : '') + '" href="' + esc((CFG.root || '') + '/products/' + x.p.h) + '" data-fl-open-handle="' + esc(x.p.h) + '">' +
        '<img src="' + esc(imgW(x.im.s, 450)) + '" alt="' + esc(x.im.a || x.p.t) + '" loading="lazy" decoding="async" width="450" height="450">' +
        '<span class="fl-cl__n">' + esc(curto(x.p)) + '</span></a>';
    }).join('');
    if (bt) {
      bt.hidden = lista.length <= lim;
      bt.textContent = CLOSE_ABERTO ? t('cl_less') : t('cl_more');
    }
  }
  function ligaClose() {
    pintaClose();
    var bt = $('[data-fl-close-more]');
    if (bt) bt.addEventListener('click', function () { CLOSE_ABERTO = !CLOSE_ABERTO; pintaClose(); });
  }

  /* ---------- atalhos da vitrine (tags do cadastro) -------------------------- */
  var FILTRO = '';
  function casaFiltro(f, p) {
    if (f.tags) return f.tags.some(function (tg) { return p.tags.indexOf(tg) > -1; });
    if (f.size) {
      var re = new RegExp('^(?:' + f.size + ')$', 'i');
      return (p.v || []).some(function (v) { return re.test(String(v.t).replace(/\s/g, '')); });
    }
    return false;
  }
  function pintaFiltros() {
    var caixa = $('[data-fl-filters]'), row = $('[data-fl-filter-row]');
    if (!caixa || !row) return;
    var fs = (V2.filters || []).map(function (f) {
      return { f: f, ps: PRODUCTS.filter(function (p) { return casaFiltro(f, p); }) };
    }).filter(function (x) { return x.ps.length > 1; });
    if (!fs.length) { caixa.hidden = true; return; }
    caixa.hidden = false;
    row.innerHTML = '<button type="button" class="fl-chip' + (FILTRO ? '' : ' is-on') + '" data-fl-filter="">' + esc(t('fi_all')) + '</button>' +
      fs.map(function (x) {
        return '<button type="button" class="fl-chip' + (FILTRO === x.f.k ? ' is-on' : '') + '" data-fl-filter="' + esc(x.f.k) + '">' +
          esc(t('fi_' + x.f.k)) + ' <small>' + fmtNum(x.ps.length) + '</small></button>';
      }).join('');
  }
  function aplicaFiltro(k) {
    FILTRO = k || '';
    var grade = $('[data-fl-filtered]'), linhas = $('[data-fl-lines]'), chips = $('[data-fl-line-chips]'), cont = $('[data-fl-filter-n]');
    if (!grade || !linhas) return;
    pintaFiltros();
    if (!FILTRO) {
      grade.hidden = true; grade.innerHTML = '';
      linhas.hidden = false; if (chips) chips.hidden = false;
      if (cont) cont.hidden = true;
      return;
    }
    var f = (V2.filters || []).filter(function (x) { return x.k === FILTRO; })[0];
    if (!f) return;
    var ps = dispPrimeiro(PRODUCTS.filter(function (p) { return casaFiltro(f, p); }));
    pinta(grade, ps);
    grade.hidden = false;
    linhas.hidden = true;
    if (chips) chips.hidden = true;
    if (cont) { cont.hidden = false; cont.textContent = t('fi_n').replace('{n}', fmtNum(ps.length)); }
  }
  function ligaFiltros() {
    var caixa = $('[data-fl-filters]');
    if (!caixa) return;
    pintaFiltros();
    caixa.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-fl-filter]') : null;
      if (!b) return;
      aplicaFiltro(b.dataset.flFilter);
    });
  }

  /* ---------- ligacao ----------------------------------------------------------------------- */
  function init() {
    $$('[data-fl-grid]').forEach(function (g) { g.setAttribute('aria-busy', 'true'); });

    cartEl = $('[data-fl-cart]'); veilEl = $('[data-fl-cart-veil]'); bodyEl = $('[data-fl-cart-body]');
    footEl = $('[data-fl-cart-foot]'); totalEl = $('[data-fl-cart-total]'); countEl = $('[data-fl-count]');
    qdEl = $('[data-fl-cart-qd]'); shipEl = $('[data-fl-cart-ship]');
    pdpOvl = $('[data-fl-pdp-ovl]'); pdpBox = $('[data-fl-pdp]');
    menuEl = $('[data-fl-menu]'); menuVeil = $('[data-fl-menu-veil]');

    ligaCabecalho();
    ligaHero();
    ligaEncaixe();
    ligaQuiz();
    ligaCrono();
    ligaClose();
    ligaFiltros();
    ligaBusca();
    renderGrids();
    bindPicker($('[data-fl-lang]'));
    bindPicker($('[data-fl-country]'));
    D.body.classList.toggle('fl-has-cart', CART.count > 0);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { $$('.fl-rail').forEach(atualizaRail); }, 150);
    });

    var btnPais = $('[data-fl-country] .fl-pick__btn');
    if (btnPais) btnPais.addEventListener('click', function (e) {
      if (tentarOrbe()) { e.stopImmediatePropagation(); fecharMenus(); }
    }, true);

    D.addEventListener('click', fecharMenus);

    /* Clique global. A ORDEM importa: controles internos da ficha, depois
       botoes de compra, depois o card (que tambem responde ao clique). */
    D.addEventListener('click', function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;

      var opt = alvo.closest('[data-fl-var]');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || !PDP.p) return;
        var nova = PDP.p.v.filter(function (v) { return Number(v.id) === Number(opt.dataset.flVar); })[0];
        if (nova) { PDP.v = nova; pintarVariante(); }
        return;
      }
      var passo = alvo.closest('[data-fl-pdp-step]');
      if (passo) { e.preventDefault(); e.stopPropagation(); porQtdPDP(pdpQtd() + Number(passo.dataset.flPdpStep)); return; }

      var add = alvo.closest('[data-fl-add]');
      if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.dataset.flAdd, false, add, add.closest('.fl-pdp') ? pdpQtd() : 1); return; }
      var buy = alvo.closest('[data-fl-buy]');
      if (buy) { e.preventDefault(); e.stopPropagation(); addToCart(buy.dataset.flBuy, true, buy, buy.closest('.fl-pdp') ? pdpQtd() : 1); return; }

      /* "Do que seu cabelo sente falta?" e o PROGRESSIVAS do menu */
      var nd = alvo.closest('[data-fl-need]');
      if (nd) { e.preventDefault(); abreNecessidade(nd.dataset.flNeed, false); return; }
      var ndGo = alvo.closest('[data-fl-need-go]');
      if (ndGo) { e.preventDefault(); fecharMenu(); abreNecessidade(ndGo.dataset.flNeedGo, true); return; }
      if (alvo.closest('[data-fl-need-close]')) { e.preventDefault(); fechaNecessidade(); return; }

      /* banners, fotos e etiquetas que levam a uma linha da vitrine completa */
      var lnGo = alvo.closest('[data-fl-line-go]');
      if (lnGo) { if (irParaLinha(lnGo.dataset.flLineGo)) { e.preventDefault(); fecharMenu(); } return; }

      /* menu do celular: fecha antes de a ancora rolar */
      var ir = alvo.closest('[data-fl-menu-go]');
      if (ir && !ir.hasAttribute('data-fl-open-handle')) { fecharMenu(); }

      /* abrir ficha (botoes do banner, busca, rodape). Produto fora do
         mercado: deixa o link seguir. */
      var abre = alvo.closest('[data-fl-open-handle]');
      if (abre) {
        if (porHandle(abre.dataset.flOpenHandle)) { e.preventDefault(); e.stopPropagation(); fecharBusca(); openPDP(abre.dataset.flOpenHandle); }
        else fecharMenu();
        return;
      }

      var termo = alvo.closest('[data-fl-term]');
      if (termo) { e.preventDefault(); abrirBusca(termo.dataset.flTerm); return; }

      var card = alvo.closest('.fl-card');
      if (card && card.dataset.flHandle) { openPDP(card.dataset.flHandle); return; }

      if (alvo.closest('[data-fl-search-open]')) { abrirBusca(); return; }
      if (alvo.closest('[data-fl-search-close]') || alvo.closest('[data-fl-search-veil]')) { fecharBusca(); return; }
      if (alvo.closest('[data-fl-menu-open]')) { abrirMenu(); return; }
      if (alvo.closest('[data-fl-menu-close]') || alvo.closest('[data-fl-menu-veil]')) { fecharMenu(); return; }
      if (alvo.closest('[data-fl-nostock-country]')) { abrirPais(); return; }
      if (alvo.closest('[data-fl-cart-open]')) { openCart(); return; }
      if (alvo.closest('[data-fl-cart-close]') || alvo.closest('[data-fl-cart-veil]')) { closeCart(); return; }
      if (alvo.closest('[data-fl-pdp-close]') || alvo === pdpOvl) { closePDP(); return; }

      var th = alvo.closest('[data-fl-th]');
      if (th) {
        var i = Number(th.dataset.flTh), main = $('[data-fl-main]');
        if (PDP.p && main && PDP.p.img[i]) {
          main.src = imgW(PDP.p.img[i].s, 900);
          main.alt = PDP.p.img[i].a || PDP.p.t;
          $$('[data-fl-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }
      var qty = alvo.closest('[data-fl-qty]');
      if (qty) {
        var linhaEl = qty.closest('.fl-cline');
        var atual = CART.items.filter(function (it) { return it.key === linhaEl.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.flQty));
        return;
      }
      var rm = alvo.closest('[data-fl-rm]');
      if (rm) { var l2 = rm.closest('.fl-cline'); if (l2) changeQty(l2.dataset.key, 0); }
    });

    /* Teclado. O popup da garantia e um checkbox: o Escape fecha SO ele quando
       estiver aberto. <label role="button"> nao responde a Enter/Espaco
       sozinho — o navegador so liga label e controle no clique. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var cbx = D.getElementById('fl-guar-cbx');
        if (cbx && cbx.checked) { cbx.checked = false; return; }
        fechaPick(); closePDP(); closeCart(); fecharBusca(); fecharMenu(); fecharMenus(); return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target;
      if (!el || !el.closest) return;
      var lbl = el.closest('label[for="fl-guar-cbx"]');
      if (lbl) { e.preventDefault(); var c = D.getElementById('fl-guar-cbx'); if (c) c.checked = !c.checked; return; }
      var card = el.closest('.fl-card');
      if (card && card === el && card.dataset.flHandle) { e.preventDefault(); openPDP(card.dataset.flHandle); }
    });

    /* O resto do catalogo e o carrinho descem EM PARALELO, depois da primeira pintura. */
    carregarResto();
    fetchCart().then(marketHint);
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
